<template>
  <div class="discount-connection-approved">
    <div class="title">הבקשה לחיבור חשבון דיסקונט אושרה על ידי הבנק!</div>
    <riseup-button :title="'המשך לאתר דיסקונט'" :variant="'discount'" :action="redirectBackToDiscount"/>
    <div class="separator"></div>
    <div class="logo-container">
      <img class="logo" :src="require('@/assets/bank-logos/discount.jpg')">
    </div>
    <div class="title">{{ errorMsg }}</div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import DiscountApi from '../../../../api/DiscountApi';
import Segment from '../../../../Segment';

export default {
  name: 'DiscountConnectionApprovedPage',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  data() {
    return {
      errorMsg: null,
    };
  },
  created() {
    Segment.trackUserGot('DiscountConnectionApprovedPageShown');
  },
  methods: {
    async redirectBackToDiscount() {
      Segment.trackUserInteraction('DiscountConnectionApprovedPage_ContinueInDiscountClicked', { idNumber: this.idNumber });
      const requestId = this.$route.query.id;
      try {
        const response = await DiscountApi.getJointAccountRedirectUrl(requestId);
        window.location.href = response.data.url;
      } catch (e) {
        this.errorMsg = e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .discount-connection-approved {
    margin: 30px;
    text-align: right;
    padding: 0 10px;

    .title {
      @include title;
      margin: 40px 0;
    }

    .text-input, .riseup-button {
      width: 100%;
    }

    .separator {
      margin-top: 96px;
      height: 1px;
      width: 100%;
      background: $riseup_gray_0;
    }

    .logo-container {
      text-align: center;

      .logo {
        width: 90px;
        margin: 20px 0;
      }
    }
  }
</style>
